export default __webpack_public_path__ + "static/media/Footer.01c4ad04.png";